import { render, staticRenderFns } from "./WhatsappWeb.vue?vue&type=template&id=c60beb20&"
import script from "./WhatsappWeb.vue?vue&type=script&lang=js&"
export * from "./WhatsappWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports